import { useQuery } from "@tanstack/react-query";

import { getClient } from "services";

const PREFILLED_PARENT_DATA = "PREFILLED_PARENT_DATA";

export default function useFetchParentData(connectionKey?: string | null) {
  async function fetchParentInformation() {
    if (connectionKey) {
      return await getClient(
        "parentsService"
      ).fetchParentInformationByEncryptedConnectionKey(
        encodeURIComponent(connectionKey)
      );
    }
  }

  return useQuery({
    queryKey: [PREFILLED_PARENT_DATA, connectionKey],
    queryFn: fetchParentInformation,
    enabled: !!connectionKey
  });
}
